export function JudgingSpeech(text) {
    const sensitiveWords = ['法沦功', '傻逼', '去死'];
    
    // 构建正则表达式，注意对特殊字符进行转义
    const pattern = new RegExp(sensitiveWords.map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'i');
    
    // 使用test方法检查文本中是否包含敏感词
    return pattern.test(text);
}